// extracted by mini-css-extract-plugin
export default {"blockwrapper":"rT","header":"sT","name":"tT","columns":"uT","imagewrapper":"vT","addinfo":"wT","description":"xT","price":"yT","old":"zT","new":"AT","desc_d":"BT","infoblock":"CT","desc_m":"ET"};
    if(module.hot) {
      // 1738064242677
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  